import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { useAuth } from "../context/AuthContext";

export default function CourseAccessGate({ children }) {
  const { currentUser, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[60vh] gap-4">
        <div className="w-10 h-10 border-4 border-[#18565b] border-t-transparent rounded-full animate-spin" />
        <p className="text-[#18565b] text-sm font-medium">Chargement...</p>
      </div>
    );
  }

  const isPremium = currentUser?.role?.toLowerCase() === "premium";

  if (isPremium) {
    return children;
  }

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex,nofollow" />
        <title>Acces reserve | Road to La Defense</title>
      </Helmet>

      <div className="max-w-3xl mx-auto px-6 py-20">
        <div className="rounded-3xl border border-[#c8e6e8] bg-gradient-to-br from-[#f4fafb] to-white p-8 md:p-10 shadow-sm text-center">
          <div className="inline-flex items-center rounded-full bg-[#18565b] px-3 py-1 text-xs font-semibold uppercase tracking-[0.18em] text-white">
            En travaux
          </div>

          <h1 className="mt-5 text-3xl md:text-4xl font-bold text-gray-900">
            Les cours sont en cours de refonte
          </h1>

          <p className="mt-4 text-base md:text-lg leading-relaxed text-gray-600">
            Le parcours cours est actuellement en chantier. Il faut encore un peu de temps avant
            sa remise en ligne propre.
          </p>

          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/"
              className="inline-flex items-center justify-center rounded-full bg-[#18565b] px-5 py-3 text-sm font-semibold text-white transition-colors hover:bg-[#15484c]"
            >
              Retour a l'accueil
            </Link>
            <Link
              to="/contact"
              className="inline-flex items-center justify-center rounded-full bg-[#e6f1f2] px-5 py-3 text-sm font-semibold text-[#18565b] transition-colors hover:bg-[#d3e7e8]"
            >
              Nous contacter
            </Link>
          </div>

          <p className="mt-5 text-sm text-gray-500">
            Merci pour ta patience pendant les travaux.
          </p>
        </div>
      </div>
    </>
  );
}
